import React from "react";

const About = () => {
  return (
    <div
      name="about"
      className="bg-gradient-to-b from-gray-800 to-black text-white md:h-auto p-4"
    >
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">
            About
          </p>
        </div>
        <p className="text-xl mt-15">
          Hello, my name is Kenny Feb Galagar. I am Software Engineer / Software
          Developer
        </p>
        <br />
        <p className="text-xl justify-normal">
          I've been a software engineer with 5+ years of experience in Java
          Spring Boot and Microservices. I've also been a Front End/Web
          Developer for 2+ years, working with React, Next.js, HTML, CSS, and
          JavaScript. I’m looking for a role where I can build scalable
          applications using modern technologies like Java microservices and
          React/Next.js, in a collaborative team that values clean code and
          continuous learning.
        </p>
        <br />
        <p className="text-xl justify-normal">
          Specializing in backend development, frontend development, and
          full-stack development. I have experience working on Java, JavaScript,
          Spring Boot, React, AWS, MySQL, PostgreSQL, Docker, Kubernetes,
          Jenkins, Git and Jira, and love building innovative solutions.
        </p>
      </div>
    </div>
  );
};

export default About;
